import { Navigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useCurrentUser } from "@/hooks/use-current-user";

/**
 * Legacy `/inbox` and `/inbox/:threadId` — the "View & reply" links in inquiry
 * emails sent before the backend switched to role-specific inbox URLs. There
 * is no `/inbox` page, so forward to the signed-in user's own inbox:
 * teachers to /teacher-inquiries, students to /my-inquiries, keeping the
 * thread selected via `?thread=`.
 */
export default function InboxRedirect() {
  const { threadId } = useParams<{ threadId?: string }>();
  const { user, isLoading } = useCurrentUser();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center" role="status" aria-label="Loading">
        <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  const roles = user?.roles?.map((r) => r.role) ?? [];
  // Single-role users go to that role's inbox; dual-role users to their current default.
  const role = roles.length === 1 ? roles[0] : user?.defaultRole;
  const base = role === "TEACHER" ? "/teacher-inquiries" : "/my-inquiries";
  const to = threadId ? `${base}?thread=${encodeURIComponent(threadId)}` : base;

  return <Navigate to={to} replace />;
}
